import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/Cryptopedia/Article/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/Cryptopedia/Homepage/GeminiPromoBanner/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/parts/NextLink/TextLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomizableSpan"] */ "/opt/build/repo/components/parts/ParseRichText/style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/parts/table/ContentfulTable/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledTable"] */ "/opt/build/repo/components/parts/table/style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerLink"] */ "/opt/build/repo/styles/disclaimer.ts");
